import Vue from "vue";
import VueRouter from "vue-router";
import DevHome from "../views/DevHome.vue";
import MockPage from "../views/MockPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: DevHome
  },
  {
    path: "/mock/:device/:channel/:env",
    name: "MockPage",
    component: MockPage
  },
  {
    // 重導向到文件
    path: "/docs/*",
    redirect: () => {
      window.location.href =
        // 文件只有在部署到 lab 環境
        "https://msc.adsmart.104-dev.com.tw/docs/index.html";
    }
  },
  {
    // 重導向到文件
    path: "/storybook/*",
    redirect: () => {
      window.location.href =
        // 文件只有在部署到 lab 環境
        "https://msc.adsmart.104-dev.com.tw/docs/index.html";
    }
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
